
import React from 'react';
import { cn } from '@/lib/utils';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';

interface BrandLogoProps {
  name: string;
  color: string;
  darkText?: boolean;
}

const BrandLogo = ({
  name,
  color,
  darkText = false
}: BrandLogoProps) => {
  return (
    <span 
      className={cn("flex items-center justify-center py-4 px-8 rounded-lg transition-all duration-300 hover:scale-110 font-bold text-lg", color, darkText ? "text-gray-800" : "text-white")} 
      style={{ minWidth: '200px' }}
    >
      {name}
    </span>
  );
};

const LogoCarousel = () => {
  // Brands data
  const brands = [
    { name: "Betsafe", color: "bg-brand-betsafe-red", darkText: false },
    { name: "Betsson", color: "bg-brand-betsson-orange", darkText: false },
    { name: "Dacia", color: "bg-brand-dacia-green", darkText: false },
    { name: "ESG Pro", color: "bg-brand-esg-purple", darkText: false },
    { name: "Keter", color: "bg-brand-keter-red", darkText: false },
    { name: "Labareau", color: "bg-brand-labareau-gold", darkText: true }
  ];

  // Create minimal duplicates for smooth animation - reduced from 4x to 2x to reduce DOM elements
  const duplicatedBrands = [...brands, ...brands];
  
  return (
    <section className="bg-white overflow-hidden py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">Trusted by Leading Brands</h2>
        
        <div className="relative overflow-hidden">
          <div className="logo-carousel-container">
            <div className="logo-carousel">
              {duplicatedBrands.map((brand, index) => (
                <BrandLogo 
                  key={index} 
                  name={brand.name} 
                  color={brand.color} 
                  darkText={brand.darkText} 
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoCarousel;
